import {
  REQUEST_LAWYER_REJECTED_CLAIMS,
  SET_LAWYER_REJECTED_CLAIMS,
  SET_SEARCH_REJECTED_CLAIMS,
  REQUEST_SEARCH_REJECTED_CLAIMS,
} from 'containers/RejectedClaimsPage/constants';

export const requestRejectedClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_LAWYER_REJECTED_CLAIMS,
  status,
  page,
  pageSize,
});

export const setRejectedClaims = (response: any) => ({
  type: SET_LAWYER_REJECTED_CLAIMS,
  response,
});

export const requestSearchRejectedClaims = (
  searchQuery: any,
  token?: string,
) => ({
  type: REQUEST_SEARCH_REJECTED_CLAIMS,
  searchQuery,
  token,
});

export const setSearchRejectedClaims = (data: any) => ({
  type: SET_SEARCH_REJECTED_CLAIMS,
  data,
});
